"use client";
import Slider from "react-slick";
import Image from "next/image";

const Hero = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: false,
    pauseOnHover: false,
  };

  const carouselImages = [
    "/images/hero/carousel-1.png",
  ];

  return (
      <section className="relative text-white  overflow-hidden mt-14 sm:mt-44 lg:mt-36">
      <div className="relative h-[20vh] sm:h-[65vh] md:h-[55vh] lg:h-[82vh] w-full -z-10">
        <Slider {...settings} className="h-full">
          {carouselImages.map((src, index) => (
            <div
              key={index}
              className="relative h-[20vh] sm:h-[65vh] md:h-[55vh] lg:h-[82vh] w-full"
            >
              <Image
                src={src}
                alt={`Slide ${index + 1}`}
                fill
                priority={index === 0}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Hero;
